// extracted by mini-css-extract-plugin
export default {"base":"Card_base__LqFCQ","title":"Card_title__W4bY2","text":"Card_text__11M4y"};